import ContentContainer from 'components/content-container/ContentContainer';
import Link from 'components/link/Link';
import Message from 'components/message/Message';
import RichText from 'components/rich-text/RichText';
import TimelineHorizontal from 'components/timeline-horizontal/TimelineHorizontal';
import Icon from 'components/icon/Icon';
import OptionsModal from 'components/options-modal/OptionsModal';
import ArticleHeader from 'components/article-header/ArticleHeader';
import TimelineVertical from 'components/timeline-vertical/TimelineVertical';
import Tabs from 'components/tabs/Tabs';
import Status from 'components/status/Status';

import ProposalData from './ProposalData';
import ProposalContact from './ProposalContact';

import { IProposalPage, Status_Theme } from 'source/NFR.types';

const ProposalPage: React.FC<IProposalPage> = ({
  applyButton,
  contact,
  contactLabel,
  download,
  metadataLeft,
  metadataRight,
  message,
  descriptionTitle,
  descriptionText,
  descriptionIngress,
  tabs,
  title,
  timelineHorizontal,
  isInternational,
  statusList,
  header,
  timelineVertical
}) => (
  <div className="proposal-page">
    <ContentContainer>
      {statusList && (
        <div className="proposal-page__status-container">
          {statusList?.map(status => (
            // <DateCardStatus {...status} key={status.text} />
            <Status key={status.text} text={status.text} theme={status.theme as unknown as Status_Theme} />
          ))}
        </div>
      )}
      {title && (
        <h1 className="proposal-page--heading" data-epi-type="title">
          {isInternational && <Icon className="proposal-page--icon" name="globe"></Icon>}
          {title}
        </h1>
      )}
      {header && <ArticleHeader {...header} />}
    </ContentContainer>
    <div className="proposal-page--header">
      <ContentContainer>
        <div className="proposal-page--metadata" data-epi-type="content">
          <div className="proposal-page--metadata-column">
            <ProposalData {...metadataLeft} />
          </div>
          <div className="proposal-page--metadata-column">
            <ProposalData {...metadataRight} />
            {contact && (
              <div className="proposal-page--contact">
                <span>{contactLabel}</span>
                <ProposalContact {...contact} />
              </div>
            )}
          </div>
        </div>
        <div className="proposal-page--header-actions">
          <Link className="proposal-page--apply-button" theme="primary" useButtonStyles {...applyButton} />
          {download && <OptionsModal className="proposal-page--download" theme="isProposalOrEvent" {...download} />}
        </div>
      </ContentContainer>
    </div>
    {message && (
      <ContentContainer className="proposal-page--message-container">
        <Message {...message} />
      </ContentContainer>
    )}
    {timelineHorizontal && <TimelineHorizontal {...timelineHorizontal} />}
    {timelineVertical && <TimelineVertical isBlock={false} {...timelineVertical} />}
    <ContentContainer className="proposal-page--description">
      {descriptionTitle && <h2 data-epi-type="title">{descriptionTitle}</h2>}
      <div data-epi-type="content">
        {descriptionIngress && <div className="proposal-page--description-ingress">{descriptionIngress}</div>}

        <RichText {...descriptionText} />
      </div>
    </ContentContainer>
    {tabs && <Tabs {...tabs} />}
  </div>
);

ProposalPage.displayName = 'ProposalPage';

export default ProposalPage;
